import { Text } from "@mantine/core";
import {
  CONTACT_NEVER_LABEL,
  CONTACT_OUTCOME_LABELS,
  CONTACTED_PREFIX,
  JOINED_PREFIX,
} from "../../constants/matching";
import { formatRelativeTime } from "../../lib/format";

export function ContactStatus({
  lastContactedAt,
  lastContactOutcome,
  joinedAt,
  size = "sm",
  lineClamp,
}: {
  lastContactedAt?: string | null;
  lastContactOutcome?: string | null;
  joinedAt?: string | null;
  size?: "sm" | "xs";
  lineClamp?: number;
}) {
  if (lastContactedAt) {
    const outcome = lastContactOutcome ? CONTACT_OUTCOME_LABELS[lastContactOutcome] ?? lastContactOutcome : null;
    const value = `${CONTACTED_PREFIX} ${formatRelativeTime(lastContactedAt)}${outcome ? ` · ${outcome}` : ""}`;
    return (
      <Text size={size} c={size === "xs" ? "dimmed" : undefined} lineClamp={lineClamp} title={value}>
        {value}
      </Text>
    );
  }
  if (joinedAt) {
    const value = `${CONTACT_NEVER_LABEL} · ${JOINED_PREFIX} ${formatRelativeTime(joinedAt)}`;
    return (
      <Text size={size} c="dimmed" lineClamp={lineClamp} title={value}>
        {value}
      </Text>
    );
  }
  return (
    <Text size={size} c="dimmed" lineClamp={lineClamp}>
      {CONTACT_NEVER_LABEL}
    </Text>
  );
}
